import Application from "@ember/application";
import Resolver from "ember-resolver";
import loadInitializers from "ember-load-initializers";
import config from "./config/environment";
import { importSync, isDevelopingApp, macroCondition } from "@embroider/macros";
import { extendResolver } from "ember-can";
// 4.12 is this package's highest entrypoint; per its README it covers all ember-source >= 4.12.
import setupInspector from "@embroider/legacy-inspector-support/ember-source-4.12";
import "@warp-drive/ember/install";
import "./polyfill";
import "./assets/app.css";

import compatModules from "@embroider/virtual/compat-modules";

/* istanbul ignore else */
if (macroCondition(isDevelopingApp())) {
  importSync("./deprecation-workflow");
}

export default class App extends Application {
  modulePrefix = config.modulePrefix;
  podModulePrefix = config.podModulePrefix;
  inspector = config.emberInspector ? setupInspector(this) : undefined;
  Resolver = extendResolver(Resolver.withModules(compatModules));
}

loadInitializers(App, config.modulePrefix, compatModules);
